import React from "react";

const BlogCard = ({ image, title, subTitle, category, description, authors, university }) => {
  return (
    <div className="w-full h-full flex flex-col rounded-2xl border border-lineColor bg-surfaceColor overflow-hidden duration-300 hover:border-designColor/50 group">
      <div className="w-full h-44 lgl:h-52 overflow-hidden relative cursor-pointer shrink-0">
        <img
          className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300 cursor-pointer"
          src={image}
          alt="blogImage"
        />
      </div>
      <div className="flex flex-col items-center flex-1 gap-2 px-5 py-5 text-center">
        <span className="text-sm text-designColor border-[1px] border-designColor px-2">
          {title}
        </span>
        <h2 className="text-base font-semibold font-titleFont text-strongColor group-hover:text-designColor duration-300">
          {subTitle}
        </h2>
        <p className="text-sm -mt-1 text-faintColor italic">{category}</p>
        <p className="clamp-mobile text-sm text-mutedColor mt-2">{description}</p>
        <p className="text-sm text-designColor mt-2">
          <strong>Authors:</strong> {authors}
        </p>
        <p className="text-sm text-designColor">
          <strong>University:</strong> {university}
        </p>
      </div>
    </div>
  );
};

export default BlogCard;
